import React from 'react';
import { MenuItems } from '@ers/data';
import { Icon } from '@ers/ui';
import Menus from '@ers/data/Menus';
import MenuItem from './MenuItem';

const createMenuItem = (type, icon, name, nameRender, prefix) => (
    <React.Fragment key={`menu-item--${type}`}>
        {prefix && prefix()}
        <MenuItem type={type}>
            {icon && <Icon name={icon} />}
            {nameRender(name)}
        </MenuItem>
    </React.Fragment>
);
const Menu = () => (
    <ul className="menu">
        {MenuItems.filter((item) => item.place === Menus.Main && Boolean(item.name)).map(({ type, icon, name, nameRender, prefix }) => createMenuItem(type, icon, name, nameRender, prefix))}
    </ul>
);

export default Menu;
